import { Dialog, Button, Box, Text } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import CautionIcon from './caution-icon.svg'

type Props = {
  visible: boolean
  onClose: () => void
  submitConfirmButton: () => void
}

const TrustScoreAgreementModal = ({ visible, onClose, submitConfirmButton }: Props) => {
  const { t } = useTranslation()

  const onConfirmHandler = () => {
    submitConfirmButton()
    onClose()
  }

  return (
    <Dialog
      id="trust-score-agreement-modal-no-data"
      open={visible}
      onClose={onClose}
      width="xsmall"
    >
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img width={'57px'} src={CautionIcon} alt="caution" style={{ paddingBottom: '24px' }} />
        <Box style={{ paddingBottom: '16px' }}>
          <Text size="large" weight="strong">
            {t('l.trust_score_agreement_modal_title', 'Trust Score Agreement')}
          </Text>
        </Box>
        <Box style={{ paddingBottom: '32px' }}>
          <Text size="standard" weight="regular" align="center">
            {t(
              'l.trust_score_agreement_modal_text1',
              'By unlocking a Trust Score, you authorize liv.rent to conduct a credit check with Equifax® based on the provided tenant information.'
            )}
          </Text>
        </Box>
        <Box style={{ paddingBottom: '32px' }}>
          <Text size="standard" weight="regular" align="center">
            {t(
              'l.trust_score_agreement_modal_text2',
              'You acknowledge and agree to ensure the accuracy of this information. liv.rent bears no responsibility for any failed credit checks resulting from inaccuracies in the provided tenant details.'
            )}
          </Text>
        </Box>
        <Box style={{ width: '100%', paddingBottom: '25px' }}>
          <Button variant="solid" onClick={onConfirmHandler}>
            {t('l.application.view.i_confirm.button', 'I Confirm')}
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

export default TrustScoreAgreementModal
